"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCertFamily = function SvgCertFamily(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#C6A378"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.633 8.307c2.689-1.413 5.506-1.718 8.36-.73C40.39 9.099 43 12.273 43.82 16.852c.412 2.3.087 4.586-.678 6.805-1.025 2.975-2.642 5.602-4.6 8.031-2.566 3.183-5.513 5.98-8.725 8.487-2.031 1.584-4.145 3.061-6.228 4.578-.456.333-.729.322-1.189.011-4.081-2.757-7.982-5.746-11.487-9.226-2.758-2.738-5.22-5.715-6.968-9.23-1.38-2.777-2.2-5.688-1.873-8.821.302-2.902 1.512-5.381 3.65-7.379 1.495-1.395 3.215-2.372 5.22-2.81 2.508-.548 4.91-.246 7.21.906 1.989.995 3.548 2.475 4.846 4.288 1.247-1.773 2.747-3.193 4.635-4.185z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 2.5,
    r: 2.5,
    transform: "matrix(-1 0 0 1 9 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 41 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 2.5,
    r: 2.5,
    transform: "matrix(-1 0 0 1 9 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.771 9.804c.523-.827 1.1-1.752 1.167-1.836.379-.476.824-.69 1.4-.685.858.007 1.718.022 2.575-.008.81-.029 1.471.21 1.955.925.17.25.407.45.615.673 1.002 1.07 2.008 2.136 3.004 3.212.353.38.606.82.48 1.378-.218.97-1.273 1.26-2.083.566-.585-.5-1.149-1.03-1.777-1.595-.025.173-.041.256-.049.34-.11 1.243.162 2.43.455 3.62.081.33.712 3.042 1.261 5.426"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.776 12.588c.484.545.849 1.028 1.278 1.414.221.198.499.42.764.509.38-.167.816-.34 1.02-.661.385-.606.004-1.478-.318-2.016l-.012.013c-.143-.174-.27-.317-.385-.472-.908-1.214-1.828-2.416-2.714-3.652-.355-.495-.77-.717-1.309-.712-.803.007-1.607.023-2.409-.009-.757-.03-1.375.218-1.828.96-.158.261-.38.47-.574.7-.937 1.112-1.878 2.22-2.81 3.337-.329.395-.566.853-.448 1.432.204 1.007 1.19 1.308 1.947.588.548-.52 1.075-1.07 1.662-1.657.024.18.039.266.046.353.102 1.291-.152 2.525-.425 3.76a316.4 316.4 0 0 0-1.131 5.306c-.186.91.261 1.85.933 2.06.838.261 1.588-.19 1.877-1.139.222-.733.433-1.47.651-2.205.332-1.115.895-3.559.909-3.497.243 1.064.745 2.45.993 3.513.192.822.352 1.662.619 2.452.438 1.298 1.81 1.286 2.41.456.39-.54.374-1.192.276-1.846-.34-2.263-.704-4.522-1.008-6.792-.09-.668-.014-1.367-.014-2.195zM.771 9.804c.523-.827 1.1-1.752 1.167-1.836.379-.476.824-.69 1.4-.685.858.007 1.718.022 2.575-.008.81-.029 1.471.21 1.955.925.17.25.407.45.615.673 1.002 1.07 2.008 2.136 3.004 3.212.353.38.606.82.48 1.378-.218.97-1.273 1.26-2.083.566-.585-.5-1.149-1.03-1.777-1.595-.025.173-.041.256-.049.34-.11 1.243.162 2.43.455 3.62.074.3.6 2.908 1.108 5.392"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCertFamily);
var _default = exports["default"] = Memo;